var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.footerCopyRight)?_c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_vm._v(" "+_vm._s(_vm.footerCopyRight)+" ")])])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }